
import { atom } from "recoil"

export const AtomCurrentBadgeAvailable = atom({
    key:'ATOMCURRENTBADGEAVAILABLE',
    default:[]
})